import { BoxProps, TextProps } from '@jfs/ui-new'

const shadowStyle = {
  shadowOffset: { width: 1, height: 1 },
  shadowRadius: 3,
  shadowColor: '#0000001F',
  borderRadius: 8,
  borderWidth: 1,
  borderColor: '#00000014',
  zIndex: 10,
}

const styles = {
  maincontainer: {
    padding: 16,
    flex: 1,
    overflow: 'auto',
    backgroundColor: 'BACKGROUND',
  } as BoxProps,
  container: {
    ...shadowStyle,
    overflow: 'hidden',
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: 'WHITE',
    borderColor: 'GRAY_BORDER',
  } as BoxProps,

  formContainer: {
    zIndex: 5,
    w: '100%',
  } as BoxProps,

  heading: {
    fontSize: 20,
    fontWeight: '700',
    color: 'BLACK_21',
  } as TextProps,
}

export default styles
